<template>
  <div id="app">
    <header-component></header-component>
    <div class="main-content">
      <router-view />
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from '@/components/shared/Header.vue'
import FooterComponent from '@/components/shared/Footer.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
    // Fetch products when the app is created
    this.$store.dispatch('fetchProducts')
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
}

a {
  text-decoration: none;
  color: inherit;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.main-content {
  min-height: calc(100vh - 180px);
  padding-bottom: 30px;
}

.btn {
  cursor: pointer;
  display: inline-block;
  padding: 10px 20px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #45a049;
}

.btn-secondary {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  color: #333;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
  border: none;
}

.btn-danger:hover {
  background-color: #c82333;
}

.section-title {
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 3px;
  background-color: #4CAF50;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>
